var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboardClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 20.9V2.1C24 0.9 23 0 21.7 0H2.3C1 0 0 0.9 0 2.1V21C0 22.1 1 23 2.3 23H21.8C23 23 24 22.1 24 20.9ZM2 20.9V2.1C2 2 2.1 1.9 2.3 1.9H21.8C21.9 1.9 22 2 22 2.1V21C22 21.1 21.9 21.2 21.7 21.2H2.3C2.1 21.1 2 21 2 20.9Z",
    fill: "#A4ACB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.5L14 11.5L18 15.5L16 17.5L12 13.5L8 17.5L6 15.5L10 11.5L6 7.5L8 5.5L12 9.5L16 5.5L18 7.5Z",
    fill: "#A4ACB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardClose);
export default __webpack_public_path__ + "static/media/keyboard-close.cb62eb7f5d69006f6cf54c6a00f38df1.svg";
export { ForwardRef as ReactComponent };